export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#FFD5E3\"/><path d=\"M16.216 7.976a3.044 3.044 0 012.771-1.791 3.05 3.05 0 013.044 3.055c0 1.42-.348 2.738-1.214 4.12a.52.52 0 00.176.735c2.45 1.353 4.462 2.136 4.462 3.928v1.183c0 .19-.155.345-.345.345h-2.95M16.217 7.976a3.45 3.45 0 012.771 3.383c0 1.624-.404 3.129-1.413 4.71a.52.52 0 00.175.737c1.867 1.03 3.517 1.766 4.412 2.745M16.216 7.976a3.45 3.45 0 00-4.127 3.383c0 1.624.404 3.129 1.413 4.71a.52.52 0 01-.175.737c-2.804 1.549-5.118 2.43-5.118 4.47v1.38c0 .19.154.344.344.344h13.97c.19 0 .345-.154.345-.345v-1.38c0-.681-.259-1.233-.707-1.724\" stroke=\"#1D1D1B\" stroke-linecap=\"square\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};